const flowDefaults = {
  templateName: '',
  isInMasterFlow: false,
};

export default flowDefaults;
